import React from "react";
import styles from "./QuoteTableSummarySkeletonLoader.module.scss";
import cx from "classnames";

interface IQuoteTableSummarySkeletonLoader {
    className?: string;
    isHighlighted: boolean;
}

const QuoteTableSummarySkeletonLoader: React.FC<IQuoteTableSummarySkeletonLoader> = (
    props
) => {
    const { className, isHighlighted } = props;

    return (
        <div
            className={cx([
                styles["loader-cell"],
                styles["basic-panel"],
                {
                    [className]: !!className,
                    [styles["is-highlighted"]]: isHighlighted
                }
            ])}>
            {/* Premium */}
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-5"],
                    styles["anim-cell-width-13_5"]
                )}
            />
            {/* Price breakdown */}
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-ml",
                    styles["anim-cell-height-1"],
                    styles["anim-cell-width-20"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-s",
                    styles["anim-cell-height-1"],
                    styles["anim-cell-width-11"]
                )}
            />
            {/* Cashback */}
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-2xl",
                    styles["anim-cell-height-3_5"],
                    styles["anim-cell-width-9"]
                )}
            />
            {/* Logo */}
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-4"],
                    styles["anim-cell-width-13_5"]
                )}
            />
            {/* Offers and Benefits */}
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-ml",
                    styles["anim-cell-height-20"]
                )}
            />
            {/* Product type */}
            <div className={cx("layout-flex-row--justify-centered")}>
                <div
                    className={cx(
                        "loading-faded",
                        "gap-pre-2xl",
                        styles["anim-cell-height-3"],
                        styles["anim-cell-width-17_5"]
                    )}
                />
            </div>
            {/* Financial Strength */}
            <div
                className={cx(
                    "layout-flex-row--justify-spaced",
                    "layout-flex-row--baseline",
                    "gap-pre-xl"
                )}>
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-30"]
                    )}
                />
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-2_5"],
                        styles["anim-cell-width-4"]
                    )}
                />
            </div>
            <div className={cx("layout-flex-row--justify-spaced", "gap-pre-s")}>
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-9"]
                    )}
                />
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-9"]
                    )}
                />
            </div>
            {/* Customer service */}
            <div
                className={cx(
                    "layout-flex-row--justify-spaced",
                    "layout-flex-row--baseline",
                    "gap-pre-xl"
                )}>
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-12_5"]
                    )}
                />
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-7_5"]
                    )}
                />
            </div>
            <div className={cx("layout-flex-row--justify-spaced", "gap-pre-s")}>
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-9"]
                    )}
                />
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-2"]
                    )}
                />
            </div>
            {/*Overall policy feature */}
            <div
                className={cx(
                    "layout-flex-row--justify-spaced",
                    "layout-flex-row--baseline",
                    "gap-pre-xl"
                )}>
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-20"]
                    )}
                />
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-7_5"]
                    )}
                />
            </div>
            <div className={cx("layout-flex-row--justify-spaced", "gap-pre-s")}>
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-9"]
                    )}
                />
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-2"]
                    )}
                />
            </div>
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-7_5"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-s",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-9"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-l",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-30"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-30"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-7_5"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-s",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-35"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-15"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-s",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-10"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-17_5"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-15"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-17_5"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-26"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-s",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-25"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-25"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-25"]
                )}
            />
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-2xl",
                    styles["anim-cell-height-1_5"],
                    styles["anim-cell-width-11"]
                )}
            />
            {/* Docs */}
            <div className={cx("gap-pre-l", "layout-flex-row--centered")}>
                <div
                    className={cx(
                        "loading-faded",
                        "space-m",
                        styles["anim-cell-height-4"],
                        styles["anim-cell-width-3"]
                    )}
                />
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-17_5"]
                    )}
                />
            </div>
            <div className={cx("gap-pre-m", "layout-flex-row--centered")}>
                <div
                    className={cx(
                        "loading-faded",
                        "space-m",
                        styles["anim-cell-height-4"],
                        styles["anim-cell-width-3"]
                    )}
                />
                <div
                    className={cx(
                        "loading-faded",
                        styles["anim-cell-height-1_5"],
                        styles["anim-cell-width-17_5"]
                    )}
                />
            </div>
            {/* View Details */}
            <div
                className={cx(
                    "loading-faded",
                    "gap-pre-ml",
                    styles["anim-cell-height-4_5"]
                )}
            />
        </div>
    );
};

export default React.memo(QuoteTableSummarySkeletonLoader);
